import React from "react";
import { useNavigate } from "react-router-dom";

const EmptyState = ({
  icon,
  title,
  description,
  ctaText,
  ctaAction,
  variant = "primary",
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (typeof ctaAction === "string") {
      navigate(ctaAction);
    } else if (typeof ctaAction === "function") {
      ctaAction();
    }
  };

  const variants = {
    primary:
      "bg-gradient-to-r from-purple-600 to-pink-500 text-white hover:opacity-90 shadow-lg shadow-purple-200 dark:shadow-none",
    secondary:
      "border-2 border-purple-500 text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20",
  };

  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6 bg-white dark:bg-gray-800/40 rounded-[2.5rem] border border-gray-100 dark:border-gray-700 shadow-xl backdrop-blur-sm">
      <div className="text-8xl mb-8 transform hover:scale-110 transition-transform duration-500 cursor-default animate-bounce-slow">
        {icon}
      </div>
      <h3 className="text-3xl font-black text-gray-900 dark:text-white mb-4 tracking-tight">
        {title}
      </h3>
      <p className="text-lg text-gray-600 dark:text-gray-400 mb-10 max-w-lg mx-auto leading-relaxed font-medium">
        {description}
      </p>
      {ctaText && (
        <button
          onClick={handleAction}
          className={`px-10 py-4 rounded-2xl font-black text-lg transition-all transform hover:scale-[1.05] active:scale-95 flex items-center gap-3 font-sans ${variants[variant]}`}
        >
          {ctaText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
